// Keep API failures out of face state; HTTP errors may contain JSON error objects.
export const fetchFaceData = async (path) => {
  const response = await fetch(path)
  if (!response.ok) {
    throw new Error(`Face data request failed (${response.status})`)
  }
  const result = await response.json()
  if (!result || !Array.isArray(result.data)) {
    throw new Error("Invalid face data response")
  }
  return { ...result, data: normalizeFaces(result.data) }
}

export const normalizeFaces = (faces) => {
  if (!Array.isArray(faces)) return []
  return faces
    .filter((face) => face && typeof face.gender === "string" && Number.isFinite(face.age))
    .map((face) => ({
      ...face,
      engines: Array.isArray(face.engines)
        ? face.engines.filter((engine) => engine && typeof engine.engine === "string")
        : [],
    }))
}

export const getFaces = (result) => (result && Array.isArray(result.data) ? result.data : [])
